import { get } from "svelte/store";

import { proxyHost } from "../config";
import { country, language } from "../store/language";
import type { PageLoad } from "./$types";
import { getQuery } from "./dataMap";
import { getSupportedSectionTypes } from "./queryMap";

async function getSections(fetch) {
  const $language = navigator.language.split("-")[0] ?? get(language);

  const response = await fetch(
    `${proxyHost}/new-content/corners/mobile/${country()}/${$language}`,
  );

  if (!response.ok) {
    return;
  }

  const sections = await response.json();

  const supportedSectionTypes = getSupportedSectionTypes();

  return sections.data
    .map((filtered) => {
      const { id, key, sectionTranslation, sectionType, shuffle, visible, order } =
        filtered;

      const sType = sectionType[0].__component;

      if (!supportedSectionTypes.includes(sType)) {
        return null;
      }

      const games = getQuery(sType, id, country(), $language, shuffle);

      return {
        __component: sectionType[0].__component,
        description: sectionTranslation?.description,
        id,
        items: games,
        key,
        locale: country(),
        order,
        section_title:
          sectionTranslation?.localizations[0]?.title ?? sectionTranslation?.title,
        shuffle,
        visible,
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      if (
        a.__component === "sections.news-section" &&
        b.__component !== "sections.news-section"
      ) {
        return 1;
      } else if (
        a.__component !== "sections.news-section" &&
        b.__component === "sections.news-section"
      ) {
        return -1;
      } else {
        return 0;
      }
    });
}

export const load = (async ({ fetch }) => {
  const data = await getSections(fetch);
  return {
    data,
  };
}) satisfies PageLoad;
